import { FieldEditorInformation } from './api/FieldEditorInformation';

export class ValueChangedModel<T> {
    object: T;
    fei: FieldEditorInformation;
}
